var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container2" },
    [
      _vm.envConfig.isBxIe()
        ? _c("div", [
            _c("div", { staticClass: "login-deco1" }),
            _c("div", { staticClass: "login-deco2" }),
            _c("div", { staticClass: "login-deco3" }),
          ])
        : _c("div", [_c("div", { staticClass: "login-right-bg" })]),
      _c("div", { staticClass: "login-weaper animated bounceInDown" }, [
        _c("p", { staticClass: "login-tip" }, [
          _vm._v(_vm._s(_vm.website.title)),
        ]),
        _c("div", { staticClass: "login-border" }, [
          _c(
            "div",
            { staticClass: "login-main" },
            [
              _c("h4", { staticClass: "login-title" }),
              _vm.activeName === "user"
                ? _c("userLogin", { ref: "refUser" })
                : _vm.activeName === "code"
                ? _c("codeLogin", { ref: "refCode" })
                : _vm._e(),
              _vm.activeName === "user"
                ? _c("div", { staticClass: "login-menu" }, [
                    _c("a", { staticClass: "active" }, [_vm._v("账号密码")]),
                    _c(
                      "a",
                      {
                        staticClass: "deactive",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.activeName = "code"
                          },
                        },
                      },
                      [_vm._v("手机号登录")]
                    ),
                  ])
                : _vm.activeName === "code"
                ? _c("div", { staticClass: "login-menu" }, [
                    _c(
                      "a",
                      {
                        staticClass: "deactive",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.activeName = "user"
                          },
                        },
                      },
                      [_vm._v("账号密码")]
                    ),
                    _c("a", { staticClass: "active" }, [_vm._v("手机号登录")]),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "login-copyright" }, [
        _c("a", [_vm._v(_vm._s(_vm.website.copyright))]),
        _c(
          "a",
          {
            staticStyle: { color: "#1e9fff" },
            attrs: {
              href: "https://beian.miit.gov.cn/#/Integrated/index",
              target: "_blank",
            },
          },
          [_vm._v("\n\t\t\t" + _vm._s(_vm.website.icp) + "\n\t\t")]
        ),
        _c("br"),
        _c("a", [_vm._v("经营保险经纪业务许可证编号:269602000000800")]),
        _c(
          "a",
          {
            staticStyle: { color: "#1e9fff" },
            attrs: { href: "http://icid.iachina.cn/", target: "_blank" },
          },
          [_vm._v("中国保监会网销许可")]
        ),
      ]),
      _c("top-color", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
      }),
      _vm.isShowEndHint
        ? _c("div", { staticClass: "login-end-hint" }, [
            _c(
              "div",
              { staticClass: "login-end-hint-content" },
              [
                _c("div", { staticClass: "login-end-hint-content-title" }, [
                  _vm._v("停用公告"),
                ]),
                _c("el-image", {
                  style: { width: "100%", height: "80px" },
                  attrs: { src: "/images/icon_end.png" },
                }),
                _vm._m(0),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-end-hint-content-text" }, [
      _c("div", { staticStyle: { color: "red" } }, [
        _vm._v("本网站从即日起已停止服务。"),
      ]),
      _c("div", [
        _vm._v(
          "如有疑问，请前往我们的企微服务群，或联系您的业务对接人进行咨询。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }